export interface CancellablePromise<T> {
  promise: Promise<T>,
  cancel: () => void
}

// Wrapper to make promises cancellable
export const makeCancellable = <T>(promise: Promise<T>) => {
  let hasCanceled = false;

  const wrappedPromise = new Promise<T>((resolve, reject) => {
    promise.then(
      (val: any) => {
        hasCanceled ? reject({ isCanceled: true }) : resolve(val)
      },
      (error: any) => {
        hasCanceled ? reject({ isCanceled: true }) : reject(error)
      }
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled = true;
    },
  };
};



// WEBPACK FOOTER //
// ./src/utils/makeCancellable.ts